import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import Footer from "../Components/common/footer";
import "../Components/SettlementDashboard/SettlementDashboard.css";
import SettlementDashboard from "../Components/SettlementDashboard/main";
import { fetchPageObject, fetchShakespeareStatus, getCaseId } from "../Utils/helper";

function SettlementPage() {
  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);
  const dispatch = useDispatch();
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 18).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  useEffect(() => {
    fetchShakespeareStatus(getCaseId(), 18, dispatch);
  }, [dispatch]);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  return (
    <>
      <div
        className={`page-wrapper settle-page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}
      >
        <Sidebar />
        <div className="page-container settle-page-container">
          <NavBar flaggedPageName={"18"} />
          <SettlementDashboard pageObj={pageObject} />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SettlementPage;
